import Link from 'next/link';
import styled from 'styled-components';

import { RecentSearchesCache } from 'search/utils/RecentSearchesCache';
import { SearchBoxButton } from 'search/styles/SearchStyles';
import { getLinkFromSearchConfig } from 'search/utils/getLinkFromSearchConfig';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { setCurrentSearchTerm } from 'store/actions/searchActions';
import { useStoreDispatch } from 'store/hooks/storeHooks';

export const SearchSuggestions = ({ suggestedSearches, error }) => {
  const storeDispatch = useStoreDispatch();

  const handleClick = (suggestedSearch) => {
    const newEntry = JSON.stringify({
      text: suggestedSearch.title,
      link: getLinkFromSearchConfig(suggestedSearch.searchConfig),
    });

    RecentSearchesCache.add(newEntry);
    storeDispatch(setCurrentSearchTerm(suggestedSearch?.searchConfig?.query || 'TERM_UNKNOWN'));

    sendTrackingEvent('SEARCH_SUGGESTION_TAP', {
      event_context: 'search_bar',
      search_string: suggestedSearch.title,
    });
  };

  if (error || !suggestedSearches) {
    return null;
  }

  return (
    <SearchSuggestions.Wrapper>
      {suggestedSearches.map((suggestedSearch) => (
        <SearchBoxButton
          key={suggestedSearch.id}
          onClick={() => handleClick(suggestedSearch)}
          data-qa="suggested_search"
        >
          <Link
            href={getLinkFromSearchConfig(suggestedSearch.searchConfig)}
            passHref
            prefetch={false}
          >
            <a>{suggestedSearch.title}</a>
          </Link>
        </SearchBoxButton>
      ))}
    </SearchSuggestions.Wrapper>
  );
};

SearchSuggestions.Wrapper = styled.div`
  margin-bottom: 24px;
`;
